// Certificate enum values stored on Orders.certificates (Postgres text[]).
// Mirrors the supplier-web CERTIFICATE_TYPES map: each enum value maps to
// a key under common.certificates in the i18n bundles. Unknown values fall
// back to the raw string so the UI never goes blank.
export const CERTIFICATE_TYPES = {
  ORDINAIRE: "common:certificates.ordinaire",
  FAIRTRADE: "common:certificates.fairtrade",
  RAINFOREST_ALLIANCE: "common:certificates.rainforest_alliance",
  BIO: "common:certificates.bio",
  MONDELEZ_COCOA_LIFE: "common:certificates.mondelez_cocoa_life",
  CARGILL_COCOA_PROMISE: "common:certificates.cargill_cocoa_promise",
  OLAM_COCOA_COMPASS: "common:certificates.olam_cocoa_compass",
  BC_COCOA_HORIZON: "common:certificates.bc_cocoa_horizon",
  MARS_COCOA_FOR_GENERATIONS: "common:certificates.mars_cocoa_for_generations",
  FAIRTRADE_USA: "common:certificates.fairtrade_usa",
  COCOA_TRACE_GOLD: "common:certificates.cocoa_trace_gold",
  COCOA_TRACE_SILVER: "common:certificates.cocoa_trace_silver",
  TONYS_OPEN_CHAIN: "common:certificates.tonys_open_chain",
  COCOA_FOR_GOOD: "common:certificates.cocoa_for_good",
  COCOA_HORIZONS: "common:certificates.cocoa_horizons",
  SYMBOL_SMALL_PRODUCERS: "common:certificates.symbol_small_producers",
  SASSANDRA: "common:certificates.sassandra",
  NESTLE_COCOA_PLAN: "common:certificates.nestle_cocoa_plan",
  TRANSPARENCE_CACAO: "common:certificates.transparence_cacao",
  OLAM_ATSOURCE: "common:certificates.olam_atsource",
  ARS1000: "common:certificates.ars1000",
} as const

export type CertificateType = keyof typeof CERTIFICATE_TYPES

export function certificateTranslationKey(value: string): string | null {
  return CERTIFICATE_TYPES[value as CertificateType] ?? null
}
